import CosmeticConfirmation from './CosmeticConfirmation';

export default CosmeticConfirmation;
